/*eslint-disable*/
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import '../../assets/styles/App.css';
import "@fontsource/montserrat";


export default function MapEditPopUp({ isOpen, onClose, onSave, objectData }) {
    const [editErrorMessage, setEditErrorMessage] = useState('');
    const history = useNavigate();
    const [mapEdited, setMapEdited] = useState({id: "",  available: "",  value: ""});

    useEffect(() => {
        if (objectData) {
            setMapEdited({
                id: objectData.id,
                available: objectData.available,
                value: objectData.value
            });
        }
    }, [objectData]);

    if (!isOpen) return null;

    const handleChange = (e) => {
        const { name, value } = e.target;
        setMapEdited((prevMap) => ({
            ...prevMap,
            [name]: value
        }));
    };

    const onSubmit = (event) => {
        event.preventDefault();
        onSave(mapEdited);
    };

    return (
        <>
                <div className="bg-dark-transparent fixed w-full flex h-screen bottom-0 z-100 px-4">
                    <div className="w-full h-full flex items-center">
                        <div className="mx-auto bg-white rounded-lg max-w-600-px py-10">
                            <div className="mb-6 rounded-t-lg">
                                <h2 className="text-24-150-no-change text-blue-v-dark text-center">Edit Available Map</h2>
                            </div>

                            <form onSubmit={onSubmit}>
                                <div className="px-8">
                                    <div className="mb-6">

                                        <div>
                                            <label className="text-16-600 text-blue-v-dark" htmlFor="email">Country
                                                Id</label>
                                        </div>
                                        <div className="mb-4">
                                            <input
                                                className="h-45-px w-full border-light-grey rounded-sm"
                                                type="text"
                                                defaultValue={objectData.id}
                                                readOnly>
                                            </input>
                                        </div>

                                        <div>
                                            <label className="text-16-600 text-blue-v-dark" htmlFor="email">Country
                                                iso3</label>
                                        </div>
                                        <div className="mb-4">
                                            <input
                                                className="h-45-px w-full border-light-grey rounded-sm"
                                                type="text"
                                                defaultValue={objectData.iso3}
                                                readOnly>
                                            </input>
                                        </div>

                                    </div>

                                    <div className="mb-6">

                                        <div>
                                            <label className="text-16-600 text-blue-v-dark" htmlFor="email">Country
                                                iso3</label>
                                        </div>
                                        <div className="mb-4">
                                            <input
                                                className="h-45-px w-full border-light-grey rounded-sm"
                                                type="text"
                                                defaultValue={objectData.name}
                                                readOnly>
                                            </input>
                                        </div>

                                    </div>

                                    <div className="mb-6">

                                        <div>
                                            <label className="text-16-600 text-blue-v-dark" htmlFor="email">List Country as Available</label>
                                        </div>
                                        <div className="mb-4">
                                            <input
                                                className="h-45-px w-full border-light-grey rounded-sm"
                                                type="text"
                                                name="available"
                                                value={mapEdited.available}
                                                placeholder={objectData.available}
                                                onChange={handleChange}>
                                            </input>
                                        </div>

                                    </div>


                                    <div className="mb-6">

                                        <div>
                                            <label className="text-16-600 text-blue-v-dark" htmlFor="email">Colour Value</label>
                                        </div>
                                        <div className="mb-4">
                                            <input
                                                className="h-45-px w-full border-light-grey rounded-sm"
                                                type="text"
                                                name="value"
                                                value={mapEdited.value}
                                                placeholder={objectData.value}
                                                onChange={handleChange}>
                                            </input>
                                        </div>

                                    </div>

                                    <div className="flex justify-center mt-8">
                                        <button
                                            className="bg-yellow text-16-19 text-blue-v-dark py-2 px-12 rounded"
                                            type="submit"
                                        >
                                            <i className="fa fa-thumbs-up" aria-hidden="true"></i>

                                            &nbsp; Save &nbsp;
                                        </button>
                                        {<button
                                            className="text-16-19 px-12 py-2 ml-3 items-center text-blue rounded"
                                            type="button"
                                            onClick={onClose}
                                        >
                                            <i className="fa fa-times" aria-hidden="true"></i>

                                            &nbsp;&nbsp; Close &nbsp;&nbsp;
                                        </button>}
                                    </div>
                                </div>
                            </form>

                            {editErrorMessage && (
                                <div className="form-error"> {editErrorMessage} </div>
                            )}


                        </div>
                    </div>
                </div>
        </>
    );
}